{
  "id": "campaign-065",
  "name": "Lazy Links",
  "seed": "campaign:65",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "....W...#...",
    "x...ooo.....",
    ".sssoFo.....",
    "....ooo.....",
    "x.b..b..b...",
    "......h.....",
    "....T*.....,",
    ".....*....,.",
    ".#...*.....,",
    "....h.......",
    "*...........",
    "*...b.......",
    "*...........",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 1,
      "y": 15
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 4
    }
  ],
  "moles": {
    "hills": 2,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 65,
  "biome": "golf",
  "par": {
    "reel": 6588,
    "push": 5715,
    "selfPropelled": 5346,
    "tractor": 4635,
    "zeroTurn": 3568,
    "fairway": 2432
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 23,
      "selfPropelled": 8,
      "tractor": 0,
      "zeroTurn": 5,
      "fairway": 9
    }
  }
}
